/**
 * Ending — the two endings together: the private Drift Map and the collective
 * Rhizome. Plus a raw session export (JSON) for documentation, and restart.
 */

import { useStore } from '../state/store.js';
import { runtime } from '../session/runtime.js';
import { DriftMap } from '../endings/DriftMap.js';
import { Rhizome } from '../endings/Rhizome.js';
import { downloadJson } from '../capture/capture.js';

interface Props {
  onRestart: () => void;
}

export function Ending({ onRestart }: Props) {
  const drift = useStore((s) => s.drift);
  const rhizome = useStore((s) => s.rhizome);

  const exportSession = () => {
    const engine = runtime.engine;
    downloadJson(
      {
        session: engine?.session ?? null,
        fragments: engine?.poolFragments() ?? [],
        drift,
        exportedAt: new Date().toISOString(),
      },
      `wintermute-session-${engine?.session.id ?? 'unknown'}.json`,
    );
  };

  return (
    <div className="ending-root">
      <div className="ending-scroll">
        {drift ? <DriftMap drift={drift} /> : <p className="empty">No drift recorded.</p>}
        {rhizome && rhizome.nodes.length > 0 ? (
          <Rhizome rhizome={rhizome} />
        ) : (
          <p className="empty">The rhizome is still empty.</p>
        )}

        <div className="ending-footer">
          <button className="secondary" onClick={exportSession}>
            Export session (JSON)
          </button>
          <button className="primary" onClick={onRestart}>
            Begin again
          </button>
        </div>
      </div>
    </div>
  );
}
